import { useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import UpsertMutation from 'mutations/billing_details/upsert';
import Form from 'components/space/billing_details/form';

const Edit = ({ handleClose, onSuccess, billingDetails }) => {
  const setError = useError();
  const [upsertMutation, { loading }] = useMutation(UpsertMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.billing_details.edit');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.billing_details.edit" />
      </ModalTypography>
      <Form
        initialValues={{
          name: billingDetails.name,
          address: billingDetails.address,
          city: billingDetails.city,
          zipCode: billingDetails.zipCode,
          taxId: billingDetails.taxId ?? '',
          email: billingDetails.email ?? '',
        }}
        processing={loading}
        onSubmit={(values) => upsertMutation({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Edit;
